import {
  REDEEM_CLOSE_POPUP,
  REDEEM_OPEN_CONFIRM,
  REDEEM_OPEN_FAIL,
  REDEEM_COUNT_SUCCESS,
  REDEEM_OPEN_BOOKING_CONFIRM,
  REDEEM_OPEN_SUCCESS
} from "../actions/types";

const INIT_STATE = {
  displayConfirm: false,
  displayFail: false,
  count: 0,
};

// POPUP : 3
export default (state = INIT_STATE, action = {}) => {
  switch (action.type) {
    case REDEEM_CLOSE_POPUP:
      document.body.classList.remove("modal-open");
      return {
        ...state,
        displayConfirm: false,
        displayFail: false,
        displaySuccess: false,
        displayBookingConfirm: false,
      };
    case REDEEM_OPEN_CONFIRM:
      document.body.classList.add("modal-open");
      return {
        ...state,
        displayConfirm: true,
        displayFail: false,
        displaySuccess: false,
        displayBookingConfirm: false,
      };

    case REDEEM_OPEN_FAIL:
      document.body.classList.add("modal-open");
      return {
        ...state,
        displayConfirm: false,
        displayFail: true,
        displaySuccess: false,
        displayBookingConfirm: false,
        displayMessage: action.payload,
      };

      case REDEEM_OPEN_BOOKING_CONFIRM:
        document.body.classList.add("modal-open");
        return {
          ...state,
          displayConfirm: false,
          displayFail: false,
          displaySuccess: false,
          displayBookingConfirm: true,
          displayBookingData: action.payload,
        };

        case REDEEM_OPEN_SUCCESS:
          document.body.classList.add("modal-open");
          return {
            ...state,
            displayConfirm: false,
            displayFail: false,
            displaySuccess: true,
            displayBookingConfirm: false,
            coupon_id : action.payload,
          };



    case REDEEM_COUNT_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    default:
      return state;
  }
};
